var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors)?_c('div',{staticClass:"error"},_vm._l((_vm.errors),function(error,index){return _c('div',{key:index},[_vm._v(_vm._s(error))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }